import React, { Component } from 'react'
import CreateUserForm from './CreateUserForm'
import { BrowserRouter as Router, withRouter, Route } from 'react-router-dom'

class SignUp extends Component {

    render() {
        const { match } = this.props

        return (
            <body className="be-splash-screen">
                <div className="be-wrapper be-login">
                    <div className="be-content">
                        <div className="main-content container-fluid">
                            <div className="splash-container">
                                <CreateUserForm match={match} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="be-scroll-top"></div>
            </body>
        );
    }
}

export default withRouter(SignUp)